import React from 'react'

const ExternalLink = (props) => {
  const {title,to,children} = props
  return(
    <a href={to} target="_blank" rel="noopener noreferrer" title={title}>{children}</a>
  )
}

export default ExternalLink